/* Mensagens e notas internas da timeline. */
import {
  forwardMessageResult,
  message,
  paginated,
  sendMessageInput,
  type ForwardMessageResult,
  type Message,
  type SendMessageInput,
} from "@zapir/shared";
import { request } from "./core";
import { timelineMessage, type Page, type TimelineMessage } from "./types";

export const messagesApi = {
  async messages(conversationId: string, cursor?: string, limit = 30): Promise<Page<TimelineMessage>> {
    return request(`/conversations/${conversationId}/messages`, {
      query: { cursor, limit },
      schema: paginated(timelineMessage),
    });
  },

  async sendMessage(input: SendMessageInput): Promise<Message> {
    const body = sendMessageInput.parse(input);
    return request(`/conversations/${body.conversationId}/messages`, {
      method: "POST",
      // `body` é omitido quando há `mediaId` (só legenda); o schema canônico
      // `sendMessageInput` valida a combinação (docs/05/06).
      body: {
        body: body.body,
        mediaId: body.mediaId,
        caption: body.caption,
        clientMessageId: body.clientMessageId,
        quotedMessageId: body.quotedMessageId,
      },
      schema: message,
    });
  },

  /** Apaga para todos no WhatsApp; a mensagem continua na timeline, esmaecida. */
  /** Encaminha para varias conversas; o servidor diz quais falharam. */
  async forwardMessage(
    conversationId: string,
    messageId: string,
    conversationIds: string[],
  ): Promise<ForwardMessageResult> {
    return request(`/conversations/${conversationId}/messages/${messageId}/forward`, {
      method: "POST",
      body: { conversationIds },
      schema: forwardMessageResult,
    }) as Promise<ForwardMessageResult>;
  },

  async deleteMessage(conversationId: string, messageId: string): Promise<TimelineMessage> {
    return request(`/conversations/${conversationId}/messages/${messageId}`, {
      method: "DELETE",
      schema: timelineMessage,
    }) as Promise<TimelineMessage>;
  },

  async sendNote(input: {
    conversationId: string;
    body: string;
    visibility?: "team" | "admins";
    mentions?: string[];
  }): Promise<TimelineMessage> {
    return request(`/conversations/${input.conversationId}/notes`, {
      method: "POST",
      body: {
        body: input.body,
        visibility: input.visibility ?? "team",
        mentions: input.mentions ?? [],
      },
      schema: timelineMessage,
    });
  },
};
